import React from "react";
import Button from '../Button.js';
import { Link } from "react-router-dom"

class Course extends React.Component {
  constructor(props){
        super(props);
        this.state={
            examples: [],
            course: this.props.course.split('\n')
        };
  }

  apply() {
    return (
      <Button
        isDisable={false}
        value={this.props.button}
        onClick={() => this.props.onClick()}
        name="Exam"
      />
    );
  }

  componentDidMount(){
  console.log("test course Component");
  console.log(this.props.course.split('\n'));
        this.getMyExample();
  }

  componentDidUpdate() {
      if (this.props.reload === true)
         this.getMyExample()
}

  getMyExample() {
  console.log(this.props.title);
  let tmp = [];
    if (localStorage.getItem('jstoken') !== "") {
      fetch(process.env.REACT_APP_API_URL + "/userupload/user/" + this.props.course_id,
      {
      headers:
        {"Authorization" : localStorage.getItem('jstoken')}
      })
      .then(res =>res.json())
      .then((res) => {
      if (res) {
        console.log(res);
          for (var i = 0; i < res.userUploads.length; i++) {
              tmp.push(res.userUploads[i].sentence);
          }
          this.setState({examples: tmp});
      }
      });
    }
    else {
        var jsonExample = JSON.parse(localStorage.getItem("upload"))
        for (var i = 0; i < jsonExample.upload.length; i++) {
            if (jsonExample.upload[i].course_id === this.props.course_id)
                tmp.push(jsonExample.upload[i].sentence)
        }
        this.setState({examples: tmp});
    }
  }

  render() {
    return (
      <div className="container mt-3" style={{ marginTop: "100px"}}>
      <div className="card">
        <div className="card-header">
          <h2 className="h4">{this.props.title}</h2>
        </div>
        <div className="card-body">
          <h3 className="h5 mb-3">Your Example</h3>
          <ul className="list-group list-group-flush mb-3">
            {this.state.examples.map((example, index) => (
              <li className="list-group-item" key={index}>
                {example}
              </li>
            ))}
          </ul>
          <hr />
          <div className="mb-3">
            {this.state.course.map((part, index) => (
              <p key={index}>{part}</p>
            ))}
          </div>
          <Link to={{ pathname: "/quiz/" + this.props.title, state: { course_id: this.props.course_id } }} className="btn btn-primary">
            Go to Exam
          </Link>
        </div>
      </div>
    </div>
    );
  }
} 

export default Course;

/*
import React from "react";
import Button from "../Button.js";
import { Link } from "react-router-dom";
import SpeechFeature from "../SpeechFeature.js";

class Course extends React.Component {
  state = {
    examples: [],
    course: this.props.course.split("\n"),
  };

  async componentDidMount() {
    console.log("test course Component");
    console.log(this.props.course.split("\n"));
    await this.getMyExample();
  }

  componentDidUpdate(prevProps) {
    if (this.props.reload && this.props.reload !== prevProps.reload) {
      this.getMyExample();
    }
  }

  getMyExample = async () => {
    console.log(this.props.title);
    let tmp = [];
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/userupload/user/${this.props.course_id}`,
        {
          headers: { Authorization: localStorage.getItem("jstoken") },
        }
      );
      const data = await res.json();
      if (data) {
        console.log(data);
        tmp = data.userUploads.map((upload) => upload.sentence);
      }
    } catch (error) {
      console.error(error);
      const jsonExample = JSON.parse(localStorage.getItem("upload"));
      tmp = jsonExample.upload
        .filter((upload) => upload.course_id === this.props.course_id)
        .map((upload) => upload.sentence);
    }
    this.setState({ examples: tmp });
  };

  render() {
    const { title, course_id } = this.props;
    return (
      <div className="Left">
        <h2>{title}</h2>
        <hr />
        <h3>Your Example</h3>
        {this.state.examples.map((exempl, index) => (
          <div key={index}>
            <p>{exempl}</p>
            <SpeechFeature text={exempl} />
          </div>
        ))}
        <hr />
        {this.state.course.map((part, index) => (
          <p key={index}>{part}</p>
        ))}
        <Link to={{ pathname: `/quiz/${title}`, state: { course_id } }}>
          Go to Exam
        </Link>
      </div>
    );
  }
}

export default Course; 

import React from "react";
import Button from '../Button.js';
import { Link } from "react-router-dom"
import SpeechFeature from '../SpeechFeature'; // Import the SpeechFeature component

class Course extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      examples: [],
      course: this.props.course.split('\n'),
      speakClicked: false, // Initialize the state variable
    };
  }

  apply() {
    return (
      <div>
        <Button
          isDisable={false}
          value={this.props.button}
          onClick={() => this.props.onClick()}
          name="Exam"
        />
        <button onClick={() => this.speechFeatureRef.speak(this.state.examples)}>
          SPEAK
        </button>
      </div>
    );
  }

  componentDidMount() {
    console.log("test course Component");
    console.log(this.props.course.split('\n'));
    this.getMyExample();
  }

  componentDidUpdate() {
    if (this.props.reload === true)
      this.getMyExample();
  }

  getMyExample() {
    console.log(this.props.title);
    let tmp = [];
    if (localStorage.getItem('jstoken') !== "") {
      fetch(process.env.REACT_APP_API_URL + "/userupload/user/" + this.props.course_id, {
        headers: {
          "Authorization": localStorage.getItem('jstoken')
        }
      })
        .then(res => res.json())
        .then((res) => {
          if (res) {
            console.log(res);
            for (var i = 0; i < res.userUploads.length; i++) {
              tmp.push(res.userUploads[i].sentence);
            }
            this.setState({ examples: tmp });
          }
        });
    } else {
      var jsonExample = JSON.parse(localStorage.getItem("upload"))
      for (var i = 0; i < jsonExample.upload.length; i++) {
        if (jsonExample.upload[i].course_id === this.props.course_id)
          tmp.push(jsonExample.upload[i].sentence)
      }
      this.setState({ examples: tmp });
    }
  }

  render() {
    return (
      <div className="Left">
        <h2>{this.props.title}</h2>
        <hr />
        <h3>Your Example</h3>
        <SpeechFeature text={this.state.examples.join("     ")} ref={(ref) => (this.speechFeatureRef = ref)} />
        {this.state.examples.map((exempl, index) => {
          return <p key={index}>{exempl}</p>;
        })}
        <hr />
        {this.state.course.map((part, index) => {
          return <p key={index}> {part} </p>;
        })}
        <Link to={{ pathname: "/quiz/" + this.props.title, state: { course_id: this.props.course_id } }}>Go to Exam</Link>
      </div>
    );
  }
}

export default Course; */
